export default __webpack_public_path__ + "static/media/autoportrait_windows_hand.859574bc.jpg";